import {
  EyeInvisibleOutlined,
  EyeOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { ReactNode, useState } from "react";
import "./Password-input.css";

type IPasswordInput = {
  icon?: ReactNode;
  name?: string;
  testId?: string;
  placeholder?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string | number | readonly string[] | undefined;
  required?: boolean;
};

const PasswordInput: React.FC<IPasswordInput> = (props: IPasswordInput) => {
  const [togglePassword, setTogglePassword] = useState(false);

  return (
    <>
      <div className="relative w-full">
        <label className="absolute -top-3 left-3 bg-white dark:bg-stone-800 px-1 text-blue-800 dark:text-blue-400 text-sm">
          {props?.placeholder}
        </label>
        <input
          required={props?.required}
          name={props?.name}
          value={props.value}
          onChange={props?.onChange}
          type={togglePassword ? " text" : "password"}
          className={
            "pl-10 pr-4 py-2 border dark:border-stone-600 rounded-lg w-full h-16 bg-transparent text-blue-800 dark:text-sky-300 placeholder-gray-500 dark:placeholder-stone-400" +
            (props.icon ? " pl-10" : " pl-4")
          }
          placeholder={props?.placeholder}
        />
        {props.icon && (
          <div
            className={
              "absolute inset-y-0 left-0 pl-3  flex items-center  pointer-events-none"
            }
          >
            {props.icon}
          </div>
        )}

        <div className={"absolute inset-y-0 right-0 pr-3  flex items-center"}>
          {togglePassword ? (
            <EyeOutlined
              onClick={() => {
                setTogglePassword(!togglePassword);
              }}
              className="passwordIcon text-blue-800 dark:text-blue-400"
              rev={undefined}
            />
          ) : (
            <EyeInvisibleOutlined
              onClick={() => {
                setTogglePassword(!togglePassword);
              }}
              className="passwordIcon text-blue-800 dark:text-blue-400"
              rev={undefined}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default PasswordInput;
